import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import cx from "classnames";

import { ImageAssetProps } from "./ImageAsset.types";

export const ImageAsset: React.FC<ImageAssetProps> = ({ title, cn, image }: ImageAssetProps) => (
  <GatsbyImage className={cx(`a-image`, cn)} alt={title} image={image} />
);
